module.exports = __webpack_public_path__ + "static/media/delivery_color.7d098b69.svg";